import React from "react";
import {
    Box,
    Divider,
    FormControl,
    FormControlLabel,
    Grid,
    MenuItem,
    Radio,
    RadioGroup,
    Select,
    Stack,
    TextField,
    Typography
} from "@mui/material";
import {DateField, LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {Trans, useTranslation} from "react-i18next";
import {mezzoTrasportoValues} from "../../config";
import {find} from "lodash";
import dayjs from "dayjs";

export const ProfileAgencyFormField = ({label, ...props}) => {
    const {t} = useTranslation()

    return (
        <Grid item xs={props.cols ? props.cols.xs : 12} sm={props.cols ? props.cols.sm : 6}>
            {(() => {
                switch (props.type) {
                    case 'divider':
                        return <Box sx={{pt: 2}}>
                            <Divider/>
                        </Box>
                    case 'note':
                        return <Box>
                            <Typography>
                                {label}
                            </Typography>
                        </Box>
                    case 'radiogroup':
                        return <FormControl sx={{pt: 2}} variant="standard"
                                            fullWidth
                                            disabled={props.precompiled}
                                            value={props.agency[props.id]}
                        >
                            {label && <Typography id={props.id}>{label}</Typography>}
                            <RadioGroup
                                aria-labelledby={props.id}
                                defaultValue={''}
                                id={props.id}
                                name={props.name}
                                disabled={props.precompiled}
                                value={props.agency[props.id]}
                                row
                            >
                                {props.values?.map(v =>
                                    <FormControlLabel value={v.value} key={v.value} control={<Radio/>}
                                                      label={t(`radio.${v.value}`)}/>
                                )}
                            </RadioGroup>
                        </FormControl>
                    case 'select':
                        return <FormControl variant="standard" fullWidth>
                            {label && <Typography id={props.id}>{label}</Typography>}
                            <Select
                                label={label ?? ''}
                                variant={"filled"}
                                id={props.id}
                                name={props.name}
                                value={props.agency[props.id]}
                                disabled={props.precompiled}
                            >
                                {props.values?.map(v =>
                                    <MenuItem value={v.value} key={v.value}>{t(`select.${v.value}`)}</MenuItem>
                                )}
                            </Select>
                        </FormControl>
                    case 'date':
                        return <LocalizationProvider dateAdapter={AdapterDayjs}>
                            {label && <Typography id={props.id}>{t(`fields.${props.id}`)}</Typography>}
                            <DateField
                                variant={"filled"}
                                name={props.id}
                                required={props.required}
                                disabled={props.precompiled}
                                disableFuture={props.disableFuture}
                                disablePast={props.disablePast}
                                id={props.id}
                                sx={{width: '100%'}}
                                format={'DD/MM/YYYY'}
                                value={dayjs(props.agency[props.id])}
                                //label={t(`fields.${props.id}`) ?? ''}
                            />
                        </LocalizationProvider>
                    case 'custom':
                        const mezzo = find(mezzoTrasportoValues, ['value', props.agency[props.id]])
                        const categoria = props.agency.categoria
                        return categoria !== 'AGENTI RMA' && categoria !== 'AGENTI ITA' && categoria !== 'AGENZIA ITA' ?
                            <Stack>
                                {mezzo ?
                                    <Typography fontWeight={'bold'} textAlign={'center'} color={'primary'}
                                                variant={'h6'}>
                                        {t('fields.note-mezzoTrasporto')}
                                        <br/>
                                        <Trans i18nKey={`fields.${mezzo.value}`}/>
                                    </Typography> : null}
                            </Stack>
                            : mezzo ?
                                mezzo.value !== 'MEZZI PROPRI' ?
                                    <Stack>
                                        <FormControl variant="standard" fullWidth>
                                            {t('fields.note-mezzoTrasporto')}
                                            {!props.precompiled ?
                                                <Select
                                                    id={props.id}
                                                    name={props.name}
                                                    label={label ?? ''}
                                                    variant={"filled"}
                                                    defaultValue={mezzo.value}
                                                    disabled={props.precompiled}
                                                >
                                                    <MenuItem value={mezzo.value}
                                                              key={mezzo.value}>{t(`fields.${mezzo.value}`)}</MenuItem>
                                                    <MenuItem value={'rma-mezzi-propri'}
                                                              key={'rma-mezzi-propri'}>{t(`fields.rma-mezzi-propri`)}</MenuItem>
                                                </Select>
                                                : <Stack>
                                                    {
                                                        props.agency['rma-mezzi-propri'] === 'si'
                                                            ? 'MEZZI PROPRI' :  t(`fields.${mezzo.value}`)
                                                    }
                                                </Stack>
                                            }
                                        </FormControl>
                                    </Stack>
                                    : <Typography fontWeight={'bold'} textAlign={'center'} color={'primary'}
                                                  variant={'h6'}>
                                        {t('fields.note-mezzoTrasporto')}
                                        <br/>
                                        <Trans i18nKey={`fields.${mezzo.value}`}/>
                                    </Typography> : null
                    default:
                        return <>
                            {label && <Typography id={props.id}>{label}</Typography>}
                            <TextField
                                id={props.id}
                                name={props.name}
                                disabled={props.precompiled}
                                multiline={props.longText}
                                minRows={props.longText ? 3 : 1}
                                variant={"filled"}
                                value={props.agency[props.id]}
                                //variant={props.longText ? "outlined" : "standard"}
                                //label={t(`fields.${props.id}`) ?? ''}
                                sx={{width: '100%'}}/>
                            </>
                }
            })()}
        </Grid>
    )
}
